module.exports = __webpack_public_path__ + "static/media/Cabs2.0-300-25-A.d96d84cc.png";